import React  from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import DeleteIcon from '@mui/icons-material/Delete';
import ButtonCustom from '../../../shared/components/buttons/ButtonCustom';
import ModalTitleCustom from '../../../shared/components/modals/ModalTitle';
import { cancelReservationExecuteState, reservationForCancelSelectedState, showModalCancelReservationState } from '../state/atoms';
import ReservationService from 'src/services/agenda/reservations';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { listReservationsRecentsFetchState } from 'src/Patient/state/atoms';
import { userState } from 'src/store/user/userState';
import useReservationsPatient from 'src/Patient/hooks/useReservationsPatient';
import { snackbarState } from 'src/store/global/snackbarState';
//import ReactGA from 'react-ga';
import ReactGA from "react-ga4";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function ModalCancelReservation() {
    const { catchErrorApi } = useCatchErrorApi();
    const user = useRecoilValue(userState);
    const [showModalCancelReservation, setShowModalCancelReservation] = useRecoilState(showModalCancelReservationState);
    const reservationForCancelSelected = useRecoilValue(reservationForCancelSelectedState);
    const resetReservationForCancel = useResetRecoilState(reservationForCancelSelectedState);
    const [cancelReservationExecute, setCancelReservationExecute] = useRecoilState(cancelReservationExecuteState);
    const refreshRecentsReservations = useRecoilRefresher_UNSTABLE(listReservationsRecentsFetchState(user.payload.uswRut));
    const { reservationsRecentsCallback } = useReservationsPatient();
    const setSnackbar = useSetRecoilState(snackbarState);
    //const resetReservationsRecents = useResetRecoilState(reservationsRecentsState)

    const handleClose = () => {
        resetReservationForCancel()
        setShowModalCancelReservation(false);
    };

    const handleClickCancel = async () => {
        setCancelReservationExecute(true)
        try {

            await ReservationService.cancelReservation({
                ptdRut: reservationForCancelSelected.ptdRut,
                agpCorrel: reservationForCancelSelected.horas[0].agpCorrel,
                ageCorrel: reservationForCancelSelected.horas[0].ageCorrel,
            });

            setSnackbar({
                openAlert: true,
                severity: "success",
                text: "Su reserva ha sido anulada con éxito",
                position: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }
            });
            
            ReactGA.event({
                category: 'Anular',
                action: `Se anulo una reserva de hora para el especialista ${reservationForCancelSelected.ptdRut}`
              });

        } catch (error) {
            catchErrorApi(error);
        } finally {
            //resetReservationsRecents()
            refreshRecentsReservations()
            reservationsRecentsCallback()
            //setLoading(false)
            handleClose()
            setCancelReservationExecute(false)
        }
    }


    return (
        <div>
            <BootstrapDialog
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={showModalCancelReservation}
            >
                <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
                    Anulación de reserva
                </ModalTitleCustom>
                <DialogContent style={{ paddingTop: 16 }}>
                    ¿Está seguro de anular la reserva?
                </DialogContent>
                <DialogActions>
                    <ButtonCustom
                        loading={cancelReservationExecute}
                        color="error"
                        autoFocus
                        onClick={handleClickCancel}
                        text="SÍ, ANULAR AHORA"
                        icon={<DeleteIcon />}
                    />

                    <ButtonCustom
                        color="default"
                        autoFocus
                        onClick={() => {
                            handleClose()
                        }}
                        text="CANCELAR"
                    //icon={<Check />}
                    />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
